import { IA_KEY } from 'helpers/ia-logic';

import { watchOpportunitiesActionsOpportunities, handleRouteEnter } from './Opportunities.saga';
import Opportunities from './OpportunitiesContainer';

export default {
  path: '/classes/:venueId/opportunities',
  component: Opportunities,
  iaKey: IA_KEY.OPPORTUNITIES,
  pathSagas: [watchOpportunitiesActionsOpportunities],
  locationSagas: [handleRouteEnter],
};
